import styled from 'styled-components'
import Loader from 'components/Common/Loader'

const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const LoadingIndicator = () => {
  return (
    <Loading>
      <Loader color='#3B42A5' size='30px' />
    </Loading>
  )
}

export default LoadingIndicator
